import { createSlice } from "@reduxjs/toolkit"
import {
  exportData,
  exportRequest,
  getBranchCountryList,
  getUserActivity,
  getUserActivityDetails,
  getCountriesFromCommonData,
  getBrandsFromCommonData,
} from "store/actions/commonAction"

const initialState = {
  userActivityLoading: true,
  itemsPerPage: 10,
  userActivityTotalPages: null,
  userActivityTotalCount: null,
  userActivityCurrentPage: null,
  userActivities: [],
  userActivityDetails: {},
  isExportingData: false,
  isImageCompressing: false,
  exportRequests: [],
  loading: false,
  itemsPerPage: 10,
  totalPages: null,
  currentPage: 1,
  isLoading: null,
  countryList: [],
  branchsList: [],
  commonCountryList: [],
  brandList: [],
}

const usersSlice = createSlice({
  name: "common", //
  initialState,
  reducers: {
    setImageCompressing(state, action) {
      state.isImageCompressing = action.payload
    },
  },
  extraReducers: builder => {
    // FETCH ALL USER ACTIVITY
    builder
      .addCase(getUserActivity.pending, state => {
        state.userActivityLoading = true
      })
      .addCase(getUserActivity.fulfilled, (state, action) => {
        state.userActivityLoading = false
        const { status, data } = action.payload || {}
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.userActivities = data
          state.userActivityTotalCount = totalCount
          state.userActivityTotalPages = totalPages
          state.userActivityCurrentPage = currentPage
        }
      })
      .addCase(getUserActivity.rejected, (state, action) => {
        state.userActivityLoading = false
      })

      // USER ACTIVITY
      .addCase(getUserActivityDetails.pending, state => {
        state.userActivityLoading = true
      })
      .addCase(getUserActivityDetails.fulfilled, (state, action) => {
        state.userActivityLoading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.userActivityDetails = data
        }
      })
      .addCase(getUserActivityDetails.rejected, (state, action) => {
        state.userActivityLoading = false
      })

      // EXPORT DATA
      .addCase(exportData.pending, state => {
        state.isExportingData = true
      })
      .addCase(exportData.fulfilled, (state, action) => {
        state.isExportingData = false
        const { status } = action.payload
      })
      .addCase(exportData.rejected, (state, action) => {
        state.isExportingData = false
      })

      // EXPORT DATA
      .addCase(exportRequest.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(exportRequest.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.exportRequests = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(exportRequest.rejected, (state, action) => {
        state.loading = false
      })

      // EXPORT DATA
      .addCase(getBranchCountryList.pending, state => {
        state.isLoading = true
      })
      .addCase(getBranchCountryList.fulfilled, (state, action) => {
        state.isLoading = false
        const { status, data } = action.payload
        if (status) {
          const { branchData, countryData } = data
          state.countryList = countryData
          state.branchsList = branchData
        }
      })
      .addCase(getBranchCountryList.rejected, (state, action) => {
        state.isLoading = false
      })

      // Countries
      .addCase(getCountriesFromCommonData.pending, state => {
        state.isLoading = true
      })
      .addCase(getCountriesFromCommonData.fulfilled, (state, action) => {
        state.isLoading = false
        const { status, data } = action.payload
        if (status) {
          state.commonCountryList = data
        }
      })
      .addCase(getCountriesFromCommonData.rejected, state => {
        state.isLoading = false
      })

      // GET BRANDS
      .addCase(getBrandsFromCommonData.pending, state => {
        state.isLoading = true
      })
      .addCase(getBrandsFromCommonData.fulfilled, (state, action) => {
        state.isLoading = false
        const { status, data } = action.payload
        if (status) {
          state.brandList = data
        }
      })
      .addCase(getBrandsFromCommonData.rejected, state => {
        state.isLoading = false
      })
  },
})

export const { setImageCompressing } = usersSlice.actions

export default usersSlice.reducer
